import { removeFilter } from '../actions/removeFilter';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { CalendarEventsFilters } from '../utils/CalendarEventsFilters';

mutator(removeFilter, actionMessage => {
    const filterIndex = getStore().currentFilters.indexOf(actionMessage.filterKey);
    getStore().currentFilters.splice(filterIndex, 1);
    if (getStore().currentFilters.length == 0) {
        getStore().currentFilters.push(CalendarEventsFilters.All);
    }
});
